import styles from './styles.module.scss';
import React, {useMemo} from 'react';
import {ReactComponent as Cashout} from 'svg/coins-fill.svg';
import {ReactComponent as Offers} from 'svg/game-controller-fill.svg';
import {ReactComponent as UserProfile} from 'svg/user-list-fill.svg';
import {RiSurveyFill} from 'react-icons/ri';
import SidebarListItem from './item';
import {APP_PATHS} from '../../../constants';

export interface ISideBarItem {
  name: string;
  routPath: string;
  Icon: any;
  children?: {name: string; routPath: string}[] | null;
  className?: string;
}

const Sidebar = () => {
  const menuList: ISideBarItem[] = useMemo(
    () => [
      {
        name: 'Games',
        routPath: `${APP_PATHS.OFFERS}`,
        Icon: (props: any) => <Offers width={24} height={24} {...props} />,
        children: null
      },
      {
        name: 'Surveys',
        routPath: `${APP_PATHS.SURVEYS}`,
        Icon: (props: any) => <RiSurveyFill width={24} height={24} {...props} />,
        children: null
      },
      {
        name: 'Cashout',
        routPath: `${APP_PATHS.CASHOUT}`,
        Icon: (props: any) => <Cashout width={24} height={24} {...props} />,
        children: null
      },
      {
        name: 'Profile',
        routPath: `${APP_PATHS.PROFILE}`,
        Icon: (props: any) => <UserProfile width={24} height={24} {...props} />,
        children: null,
        className: 'profileItem' // Pass a custom class to hide on small screens
      }
    ],
    []
  );

  return (
    <div className={styles.sidebarWrapper}>
      <ul className={styles.list}>
        <SidebarListItem data={menuList} />
      </ul>
    </div>
  );
};

export default Sidebar;
